import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "tw-overflow-x-auto" }
const _hoisted_2 = { class: "tw-min-w-full tw-text-left tw-text-sm tw-text-slate-700" }
const _hoisted_3 = { class: "tw-bg-slate-50/70 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600" }
const _hoisted_4 = {
  key: 0,
  class: "tw-px-4 tw-py-3"
}
const _hoisted_5 = {
  key: 1,
  class: "tw-px-4 tw-py-3"
}
const _hoisted_6 = {
  key: 2,
  class: "tw-px-4 tw-py-3"
}
const _hoisted_7 = { class: "tw-divide-y tw-divide-slate-200/70" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "tw-px-4 tw-py-3 tw-font-medium tw-text-slate-900 tw-whitespace-nowrap" }
const _hoisted_10 = {
  key: 0,
  class: "tw-px-4 tw-py-3 tw-whitespace-nowrap"
}
const _hoisted_11 = { class: "uk-margin-remove-bottom" }
const _hoisted_12 = { class: "uk-margin-remove-top" }
const _hoisted_13 = {
  key: 1,
  class: "tw-px-4 tw-py-3 tw-whitespace-nowrap"
}
const _hoisted_14 = { class: "uk-margin-remove-bottom" }
const _hoisted_15 = { class: "uk-margin-remove-top" }
const _hoisted_16 = {
  key: 2,
  class: "tw-px-4 tw-py-3 tw-whitespace-nowrap"
}
const _hoisted_17 = {
  key: 3,
  class: "tw-px-4 tw-py-3 tw-whitespace-nowrap"
}
const _hoisted_18 = {
  key: 4,
  class: "tw-px-4 tw-py-3 tw-whitespace-nowrap"
}
const _hoisted_19 = {
  key: 5,
  class: "tw-px-4 tw-py-3 tw-whitespace-nowrap"
}
const _hoisted_20 = { class: "tw-px-4 tw-py-3 tw-whitespace-nowrap" }
const _hoisted_21 = {
  key: 6,
  class: "tw-px-4 tw-py-3 tw-whitespace-nowrap"
}
const _hoisted_22 = {
  key: 7,
  class: "tw-px-4 tw-py-3 tw-whitespace-nowrap"
}
const _hoisted_23 = { class: "tw-px-4 tw-py-3 tw-whitespace-nowrap" }
const _hoisted_24 = { class: "tw-px-4 tw-py-3 tw-whitespace-nowrap" }
const _hoisted_25 = { class: "tw-px-4 tw-py-3 tw-whitespace-nowrap" }
const _hoisted_26 = { class: "tw-px-4 tw-py-3 tw-whitespace-nowrap" }
const _hoisted_27 = { class: "tw-px-4 tw-py-3 tw-whitespace-nowrap" }
const _hoisted_28 = {
  key: 0,
  class: "uk-margin-right",
  "uk-spinner": ""
}
const _hoisted_29 = ["disabled", "onClick"]
const _hoisted_30 = {
  key: 0,
  class: "uk-margin-right",
  "uk-spinner": ""
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { "uk-dropdown": "mode: click; duration: 0" }
const _hoisted_33 = { class: "uk-nav uk-dropdown-nav" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "uk" }
const _hoisted_36 = ["href"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_FilterableDropdown = _resolveComponent("FilterableDropdown")!
  const _component_HourGlass = _resolveComponent("HourGlass")!
  const _component_EventSchedule = _resolveComponent("EventSchedule")!
  const _component_TripTypeField = _resolveComponent("TripTypeField")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _createElementVNode("thead", _hoisted_3, [
          _createElementVNode("tr", null, [
            _cache[5] || (_cache[5] = _createElementVNode("th", { class: "tw-px-4 tw-py-3" }, "Order Id", -1)),
            (!_ctx.appointmentsView)
              ? (_openBlock(), _createElementBlock("th", _hoisted_4, "Scheduled Date"))
              : (_ctx.terminalAppt)
                ? (_openBlock(), _createElementBlock("th", _hoisted_5, "Terminal Appointment"))
                : (_openBlock(), _createElementBlock("th", _hoisted_6, "Delivery Appointment")),
            _cache[6] || (_cache[6] = _createElementVNode("th", { class: "tw-px-4 tw-py-3" }, "Driver", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("th", { class: "tw-px-4 tw-py-3" }, "Container", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("th", { class: "tw-px-4 tw-py-3" }, "Chassis", -1)),
            _cache[9] || (_cache[9] = _createElementVNode("th", { class: "tw-px-4 tw-py-3" }, "Size/Type", -1)),
            _cache[10] || (_cache[10] = _createElementVNode("th", { class: "tw-px-4 tw-py-3" }, "Origin", -1)),
            _cache[11] || (_cache[11] = _createElementVNode("th", { class: "tw-px-4 tw-py-3" }, "Destination", -1)),
            _cache[12] || (_cache[12] = _createElementVNode("th", { class: "tw-px-4 tw-py-3" }, "Move", -1)),
            _cache[13] || (_cache[13] = _createElementVNode("th", { class: "tw-px-4 tw-py-3" }, "Receiver", -1)),
            _cache[14] || (_cache[14] = _createElementVNode("th", { class: "tw-px-4 tw-py-3" }, null, -1))
          ])
        ]),
        _createElementVNode("tbody", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mergedTrips, (trip, containerIdx) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: `${containerIdx}-${trip && trip.id ? trip.id : 'trip'}`,
              class: "tw-cursor-pointer hover:tw-bg-slate-900/5",
              onClick: ($event: any) => (_ctx.selectTrip(trip))
            }, [
              _createElementVNode("td", _hoisted_9, _toDisplayString(trip.container.order.id), 1),
              (_ctx.deliveryAppt)
                ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
                    _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.formatAppointmentDatetime(
                  trip.container.deliveryAppointmentDate,
                  trip.container.deliveryAppointmentHasTime,
                  (_ctx.showFullYear = true),
                ).split('@')[0]), 1),
                    _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.formatAppointmentDatetime(
                  trip.container.deliveryAppointmentDate,
                  trip.container.deliveryAppointmentHasTime,
                  (_ctx.showFullYear = true),
                ).split('@')[1]), 1)
                  ]))
                : (_ctx.terminalAppt)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                      _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.formatAppointmentDatetime(
                  trip.container.terminalAppointmentDate,
                  trip.container.terminalAppointmentHasTime,
                  (_ctx.showFullYear = true),
                ).split('@')[0]), 1),
                      _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.formatAppointmentDatetime(
                  trip.container.terminalAppointmentDate,
                  trip.container.terminalAppointmentHasTime,
                  (_ctx.showFullYear = true),
                ).split('@')[1]), 1)
                    ]))
                  : (_ctx.editingTrip.id == trip.id)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                        _createVNode(_component_DatePicker, {
                          class: "uk-form-label",
                          "input-class": 'uk-input uk-width-small',
                          format: "MM/DD/YYYY",
                          modelValue: trip.scheduledDate,
                          "onUpdate:modelValue": ($event: any) => ((trip.scheduledDate) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]))
                    : (_openBlock(), _createElementBlock("td", _hoisted_17, _toDisplayString(trip.scheduledDate ? _ctx.formatDate(trip.scheduledDate) : '--'), 1)),
              (_ctx.editingTrip.id === trip.id)
                ? (_openBlock(), _createElementBlock("td", _hoisted_18, [
                    _createVNode(_component_FilterableDropdown, {
                      modelValue: _ctx.editingTrip.driver,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editingTrip.driver) = $event)),
                      options: _ctx.drivers,
                      class: "uk-padding-remove-left uk-padding-remove-right uk-width-medium",
                      label: "fullName",
                      components: { OpenIndicator: null, Deselect: null }
                    }, null, 8, ["modelValue", "options"])
                  ]))
                : (_openBlock(), _createElementBlock("td", _hoisted_19, _toDisplayString(trip.driver ? trip.driver.fullName : ''), 1)),
              _createElementVNode("td", _hoisted_20, [
                _createTextVNode(_toDisplayString(trip.container.containerId !== 'EXPUNDEF'
                ? trip.container.containerId
                : 'Container Undefined') + " ", 1),
                (trip.container.terminalAppointmentDate)
                  ? (_openBlock(), _createBlock(_component_HourGlass, {
                      key: 0,
                      "uk-tooltip": "Container has Terminal Appointment"
                    }))
                  : _createCommentVNode("", true),
                (trip.container.deliveryAppointmentDate)
                  ? (_openBlock(), _createBlock(_component_EventSchedule, {
                      key: 1,
                      "uk-tooltip": "Container has Delivery Appointment"
                    }))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.editingTrip.id === trip.id)
                ? (_openBlock(), _createElementBlock("td", _hoisted_21, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editingTrip.chassis) = $event)),
                      class: "uk-input uk-form-small uk-form-width-small",
                      placeholder: "Chassis"
                    }, null, 512), [
                      [_vModelText, _ctx.editingTrip.chassis]
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("td", _hoisted_22, _toDisplayString(trip.chassis), 1)),
              _createElementVNode("td", _hoisted_23, _toDisplayString(trip.container.size) + "/" + _toDisplayString(trip.container.type), 1),
              _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.addressName(trip.origin)), 1),
              _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.addressName(trip.destination)), 1),
              _createElementVNode("td", _hoisted_26, [
                _createVNode(_component_TripTypeField, {
                  showLabel: false,
                  trip: trip,
                  isEditing: _ctx.editingTrip.id === trip.id,
                  darkGreen: trip.status == 'Complete',
                  gray: trip.status != 'Complete' && trip.status != 'In Progress',
                  green: trip.status == 'In Progress'
                }, null, 8, ["trip", "isEditing", "darkGreen", "gray", "green"])
              ]),
              _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.customerText(trip)), 1),
              _createElementVNode("td", {
                class: "tw-px-4 tw-py-3 tw-text-right",
                onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
              }, [
                (
                trip.status != 'In Progress' &&
                trip.status != 'Complete' &&
                _ctx.editingTrip.id !== trip.id
              )
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "tw-inline-flex tw-items-center tw-rounded-lg tw-bg-emerald-600 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-emerald-700",
                      disabled: _ctx.loadingTripId === trip.id,
                      onClick: ($event: any) => (_ctx.startTrip(trip))
                    }, {
                      default: _withCtx(() => [
                        (_ctx.loadingTripId === trip.id)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.loadingTripId === trip.id ? 'Starting...' : 'Start Trip'), 1)
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"]))
                  : (
                trip.status == 'In Progress' && _ctx.editingTrip.id !== trip.id
              )
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "tw-inline-flex tw-items-center tw-rounded-lg tw-bg-slate-900 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-slate-800",
                        disabled: _ctx.loadingTripId === trip.id,
                        onClick: ($event: any) => (_ctx.completeTrip(trip))
                      }, [
                        (_ctx.loadingTripId === trip.id)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.loadingTripId === trip.id ? 'Completing...' : 'Complete Trip'), 1)
                      ], 8, _hoisted_29))
                    : _createCommentVNode("", true),
                (_ctx.editingTrip.id === trip.id)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      class: "tw-inline-flex tw-items-center tw-rounded-lg tw-bg-slate-900 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-slate-800",
                      onClick: ($event: any) => (_ctx.saveTrip(trip))
                    }, " Save Trip ", 8, _hoisted_31))
                  : _createCommentVNode("", true),
                (_ctx.editingTrip.id === trip.id)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      class: "tw-ml-2 tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-backdrop-blur tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-white",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelEditTrip && _ctx.cancelEditTrip(...args)))
                    }, " Cancel "))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 4,
                      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _cache[19] || (_cache[19] = _createElementVNode("button", {
                        class: "tw-ml-2 tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-backdrop-blur tw-text-slate-700 hover:tw-bg-white",
                        type: "button",
                        "aria-label": "More",
                        title: "More"
                      }, [
                        _createElementVNode("span", { "uk-icon": "icon:  cog" })
                      ], -1)),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("ul", _hoisted_33, [
                          _createElementVNode("li", {
                            onClick: ($event: any) => (_ctx.editTrip(trip))
                          }, [...(_cache[15] || (_cache[15] = [
                            _createElementVNode("a", null, "Edit Trip", -1)
                          ]))], 8, _hoisted_34),
                          _createElementVNode("li", _hoisted_35, [
                            _createElementVNode("a", {
                              href: 
                        _ctx.printDispatchURL(
                          trip.container.id,
                          trip.id,
                          trip.container.order.id,
                        )
                      ,
                              target: "_blank"
                            }, "Print Dispatch Sheet", 8, _hoisted_36)
                          ]),
                          (
                      trip.status != 'Complete' && trip.status == 'In Progress'
                    )
                            ? (_openBlock(), _createElementBlock("li", {
                                key: 0,
                                onClick: ($event: any) => (_ctx.completeTrip(trip))
                              }, [...(_cache[16] || (_cache[16] = [
                                _createElementVNode("a", null, "Complete Trip", -1)
                              ]))], 8, _hoisted_37))
                            : _createCommentVNode("", true),
                          (trip.status == _ctx.TRIP_STATUS.NOT_STARTED)
                            ? (_openBlock(), _createElementBlock("li", {
                                key: 1,
                                onClick: ($event: any) => (_ctx.startTrip(trip))
                              }, [...(_cache[17] || (_cache[17] = [
                                _createElementVNode("a", null, "Start Trip", -1)
                              ]))], 8, _hoisted_38))
                            : _createCommentVNode("", true),
                          (
                      trip.status == _ctx.TRIP_STATUS.IN_PROGRESS ||
                      trip.status === _ctx.TRIP_STATUS.COMPLETE
                    )
                            ? (_openBlock(), _createElementBlock("li", {
                                key: 2,
                                onClick: ($event: any) => (_ctx.revertTrip(trip))
                              }, [...(_cache[18] || (_cache[18] = [
                                _createElementVNode("a", null, "Revert Trip", -1)
                              ]))], 8, _hoisted_39))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
              ])
            ], 8, _hoisted_8))
          }), 128))
        ])
      ])
    ])
  ]))
}